var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgComfort = function SvgComfort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3.455 19v-1.636M16.546 19v-1.636M16.545 7.71V2.635A1.637 1.637 0 0 0 14.91 1H5.091a1.636 1.636 0 0 0-1.636 1.636V7.71M19 17.364v-6.955a2.045 2.045 0 0 0-2.046-2.045v0a2.045 2.045 0 0 0-2.045 2.045v2.864H5.091v-2.864a2.045 2.045 0 0 0-4.091 0v6.955z"
  })));
};
export default SvgComfort;